import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Heading } from "@chakra-ui/react";
import { FullBleedSection, MaxContentSection } from "~/components";
import { useGetMembershipPaymentAction } from "../hooks";
import { FormBox } from "./FormBox";

export const Body: FC = () => {
  const { t } = useTranslation();
  const action = useGetMembershipPaymentAction();
  const base = `planPayment.${action}` as const;

  return (
    <FullBleedSection bgColor="bg-main" justify="flex-start" flexGrow={1}>
      <MaxContentSection
        alignItems="center"
        gap={{ base: "2rem", md: 12 }}
        justify="flex-start"
        h="full"
        pb={14}
        w="full"
      >
        <Heading as="h1" textAlign="center" variant="th-h2">
          {t(`${base}.title`)}
        </Heading>
        <FormBox />
      </MaxContentSection>
    </FullBleedSection>
  );
};
